<template>
    <div class="float-left mr-1">
        <span :class="`text-${cor}`">
            <i
                :class="`fa ${icone} fa-lg icon-button`"
                :title="titulo"
                @click.stop="exibirMetas()"
            ></i>
        </span>
    </div>
</template>

<script>

export default {
    props: {
        acao: {
            type: Object,
            default: () => ({})
        },

        titulo: {
            type: String,
            default: () => 'Metas'
        },

        icone: {
            type: String,
            default: () => 'fa-bars'
        },

        cor: {
            type: String,
            default: () => 'primary'
        },
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {}
    },

    methods: {
        exibirMetas() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterMetasPorAcao(
                this.acao.acaoId)
                .then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarMeta', response.data),
                        this.$emit('receberAcao', this.acao)
                    } else {
                        this.$toast.error(
                            'Erro ao obter as metas da ação.',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },
}
</script>
